<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Post réseaux sociaux</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'socialNetworkPostCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter un post
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Nom
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(socialNetworkPost, socialNetworkPostIndex) in socialNetworkPosts"
              :key="'c'+ socialNetworkPostIndex"
            >
              <td class="font-weight-bold">
                {{ socialNetworkPost.name }}
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'socialNetworkPostDetails', params: { socialNetworkPostId: socialNetworkPost.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiPen }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteSocialNetworkPostDialog(socialNetworkPost)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteSocialNetworkPostDialog
        :key="Date.now()"
        :delete-social-network-post-dialog-state="deleteSocialNetworkPostDialogState"
        :social-network-post="socialNetworkPostToDelete"
        @closeDeleteSocialNetworkPostDialog="closeDeleteSocialNetworkPostDialog($event)"
      ></DeleteSocialNetworkPostDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPen, mdiBackupRestore, mdiDatabaseSearchOutline, mdiTrashCan } from '@mdi/js'
import Vue from 'vue'
import config from '../../../config'
import Loader from '@/components/Common/Loader'
import DeleteSocialNetworkPostDialog from '@/components/Dialog/SocialNetworkPostDialog/DeleteSocialNetworkPostDialog'

export default {
  components: { DeleteSocialNetworkPostDialog, Loader },
  data: () => ({
    loading: false,
    socialNetworkPosts: [],
    nextPage: 1,
    socialNetworkPostToDelete: null,
    deleteSocialNetworkPostDialogState: false,
    icons: {
      mdiPen,
      mdiBackupRestore,
      mdiDatabaseSearchOutline,
      mdiTrashCan
    }
  }),
  computed: {
    isHandlingSocialNetworkPostScroll () {
      return this.$store.getters.isHandlingSocialNetworkPostScroll
    }
  },
  watch: {
    $route: function () {
      this.socialNetworkPosts = []
      this.nextPage = 1
      this.getSocialNetworkPosts()
    }
  },
  created () {
    this.getSocialNetworkPosts()

    window.removeEventListener('scroll', this.handleScroll)

    setTimeout(() => {
      window.addEventListener('scroll', this.handleScroll)
    }, 1000)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const wrapperOffsetHeight = document.querySelector('.v-application--wrap').offsetHeight
      const bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) === wrapperOffsetHeight

      if (bottomOfWindow && !this.isHandlingSocialNetworkPostScroll) {
        this.getSocialNetworkPosts()
      }
    },
    getSocialNetworkPosts () {
      this.loading = true

      const params = {
        page: this.nextPage,
        locale: this.$route.params.locale
      }

      this.$store.commit('setHandlingSocialNetworkPostScroll', true)

      Vue.prototype.$http
        .get(config.apiUrl + '/api/social-network-posts', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const socialNetworkPosts = response.data

            if (socialNetworkPosts && socialNetworkPosts.length) {
              this.socialNetworkPosts.push(...socialNetworkPosts)

              this.nextPage = this.nextPage + 1
            }
          }

          this.loading = false
          this.$store.commit('setHandlingSocialNetworkPostScroll', false)
        })
        .catch(() => {
          this.loading = false
          this.$store.commit('setHandlingSocialNetworkPostScroll', false)
        })
    },
    openDeleteSocialNetworkPostDialog (socialNetworkPost) {
      this.deleteSocialNetworkPostDialogState = true
      this.socialNetworkPostToDelete = socialNetworkPost
    },
    closeDeleteSocialNetworkPostDialog (deleteState) {
      if (deleteState === true) {
        this.socialNetworkPosts = this.socialNetworkPosts.filter(element => element.id !== this.socialNetworkPostToDelete.id)
      }

      this.deleteSocialNetworkPostDialogState = false
    }
  }
}
</script>

<style lang="scss">
.global-actions {
  margin-bottom: 1rem;
}
.action {
  margin-right: 0.5rem;
}
.v-chip-light-bg {
  margin-right: 0.5rem;
}
.clear {
  clear: both;
}
</style>
